import { Company, CompanySettings } from './types';

export const CompanySettingsMap: CompanySettings = {
  DDS: {
    company: Company.DDS,
    domain: 'ddsexpress',
    supportPhoneNumber: '8446075366',
    supportExtension: '6150',
    theme: {
      xLargeLogoUrl: '/logos/DDS-X-Large.png',
      largeLogoUrl: '/logos/DDS-Large.png',
      regularLogoUrl: '/logos/DDSB.png',
      smallLogoUrl: '/logos/DDS.png',
      palette: {
        primary: {
          main: '#00add8',
          dark: '#007997',
          light: '#33bddf',
          contrastText: '#fff'
        },
        secondary: {
          main: '#54565a',
          dark: '#3a3c3e',
          light: '#76777b',
          contrastText: '#fff'
        },
        titleBarRgb: { main: '255, 255, 255' }
      }
    },
    divisions: {
      // DD&S Express
      DDSB: {
        theme: {
          regularLogoUrl: '/logos/DDSB.png',
          smallLogoUrl: '/logos/DDS.png'
        }
      },
      // DD&S Logistics
      DDGQ: {
        theme: {
          regularLogoUrl: '/logos/DDGQ.png',
          smallLogoUrl: '/logos/DDS.png'
        }
      }
    }
  },
  Eastern: {
    company: Company.Eastern,
    domain: 'easternexpressinc',
    supportPhoneNumber: '8003486514',
    supportExtension: '6150',
    theme: {
      xLargeLogoUrl: '/logos/Eastern-X-Large.png',
      largeLogoUrl: '/logos/Eastern-Large.png',
      regularLogoUrl: '/logos/Eastern.png',
      smallLogoUrl: '/logos/Eastern.png',
      palette: {
        primary: {
          main: '#00b14c',
          dark: '#007b35',
          light: '#33c06f',
          contrastText: '#000'
        },
        secondary: {
          main: '#898a8d',
          dark: '#5f6062',
          light: '#a0a1a3',
          contrastText: '#000'
        },
        titleBarRgb: { main: '255, 255, 255' }
      }
    },
    divisions: {
      EARL: {
        theme: {}
      }
    }
  },
  Horizon: {
    company: Company.Horizon,
    domain: 'horizonfreightsystem',
    supportPhoneNumber: '8004806829',
    supportExtension: '6150',
    powerBiSplash: {
      workspaceId: '1441e3f2-0daf-4057-af77-c610340a6fc3',
      reportId: 'c5295bf4-0802-42bb-a1ef-c60a6d3387d9',
      pageName: '8d8998ef3dad8ada0cb1'
    },
    theme: {
      xLargeLogoUrl: '/logos/Horizon-X-Large.png',
      largeLogoUrl: '/logos/Horizon-Large.png',
      regularLogoUrl: '/logos/Horizon.png',
      smallLogoUrl: '/logos/Horizon.png',
      palette: {
        primary: {
          main: '#a73439',
          dark: '#742427',
          light: '#b85c60',
          contrastText: '#fff'
        },
        secondary: {
          main: '#898a8d',
          dark: '#5f6062',
          light: '#a0a1a3',
          contrastText: '#faf9f6'
        },
        titleBarRgb: { main: '167, 52, 57' }
      }
    },
    divisions: {
      // Demo Site used in CI for generically branded videos
      BESS: {
        theme: {
          regularLogoUrl: '/logos/Generic_Logo.png',
          smallLogoUrl: '/logos/Generic_Logo.png',
          palette: {
            primary: {
              main: '#5a676f',
              dark: '#39444a',
              light: '#7b8c95',
              contrastText: '#fff'
            },
            secondary: {
              main: '#a3aaad',
              dark: '#737678',
              light: '#c1c8ca',
              contrastText: '#000'
            },
            titleBarRgb: { main: '91, 103, 113' }
          }
        }
      },
      // Horizon Freight System, Inc
      HZNF: {
        theme: {
          regularLogoUrl: '/logos/HZNF.png',
          smallLogoUrl: '/logos/HZNF.png',
          components: {
            MuiAlert: {
              defaultProps: {
                variant: 'standard'
              }
            }
          }
        }
      },
      // Horizon Mid-Atlantic
      HMAC: {
        theme: {
          regularLogoUrl: '/logos/HMAC.png',
          smallLogoUrl: '/logos/HMAC.png',
          components: {
            MuiAlert: {
              defaultProps: {
                variant: 'standard'
              }
            }
          }
        }
      },
      // Horizon Mid-West
      HZMQ: {
        theme: {
          regularLogoUrl: '/logos/HZMQ.png',
          smallLogoUrl: '/logos/HZMQ.png',
          components: {
            MuiAlert: {
              defaultProps: {
                variant: 'standard'
              }
            }
          }
        }
      },
      // Horizon South
      HZSN: {
        theme: {
          regularLogoUrl: '/logos/HZSN.png',
          smallLogoUrl: '/logos/HZSN.png',
          components: {
            MuiAlert: {
              defaultProps: {
                variant: 'standard'
              }
            }
          }
        }
      },
      // Horizon West
      HZWI: {
        theme: {
          regularLogoUrl: '/logos/HZWI.png',
          smallLogoUrl: '/logos/HZWI.png',
          components: {
            MuiAlert: {
              defaultProps: {
                variant: 'standard'
              }
            }
          }
        }
      },
      //Elite One
      HZEM: {
        theme: {
          regularLogoUrl: '/logos/HZEM.png',
          smallLogoUrl: '/logos/HZEM-Compact.png',
          palette: {
            primary: {
              main: '#31006f',
              dark: '#22004d',
              light: '#5a338b',
              contrastText: '#fff'
            },
            secondary: {
              main: '#89898c',
              dark: '#5f5f62',
              light: '#a0a0a3',
              contrastText: '#000'
            },
            titleBarRgb: { main: '49, 0, 111' }
          }
        }
      },
      //CCI
      HWIH: {
        theme: {
          regularLogoUrl: '/logos/HWIH.png',
          smallLogoUrl: '/logos/HWIH-Compact.png',
          palette: {
            primary: {
              main: '#002d74',
              dark: '#001f51',
              light: '#33578f',
              contrastText: '#fff'
            },
            secondary: {
              main: '#5692db',
              dark: '#3c6699',
              light: '#77a7e2',
              contrastText: '#000'
            },
            titleBarRgb: { main: '0, 45, 116' }
          }
        }
      }
    }
  },
  Kaplan: {
    company: Company.Kaplan,
    domain: 'kaplantrucking',
    supportPhoneNumber: '8003522848',
    supportExtension: '6150',
    theme: {
      xLargeLogoUrl: '/logos/Kaplan-X-Large.png',
      largeLogoUrl: '/logos/Kaplan-Large.png',
      regularLogoUrl: '/logos/Kaplan.png',
      smallLogoUrl: '/logos/Kaplan.png',
      palette: {
        primary: {
          main: '#00774b',
          dark: '#005334',
          light: '#33926f',
          contrastText: '#fff'
        },
        secondary: {
          main: '#898a8d',
          dark: '#5f6062',
          light: '#a0a1a3',
          contrastText: '#000'
        },
        titleBarRgb: { main: '255, 255, 255' }
      }
    },
    divisions: {
      KPLN: {
        theme: {}
      }
    }
  },
  TRX: {
    company: Company.TRX,
    domain: 'trxtrucking',
    supportPhoneNumber: '8552599259',
    supportExtension: '6150',
    powerBiSplash: {
      workspaceId: '89dccb51-04d9-4855-92a1-3637a691d253',
      reportId: '86affe1e-d889-4e61-90a8-7d36e5904f83',
      pageName: '8d8998ef3dad8ada0cb1'
    },
    theme: {
      xLargeLogoUrl: '/logos/TRX-X-Large.png',
      largeLogoUrl: '/logos/TRX-Large.png',
      regularLogoUrl: '/logos/TRX.png',
      smallLogoUrl: '/logos/TRX.png',
      palette: {
        primary: {
          main: '#002856',
          dark: '#001c3c',
          light: '#335377',
          contrastText: '#fff'
        },
        secondary: {
          main: '#bbbbbb',
          dark: '#828282',
          light: '#c8c8c8',
          contrastText: '#000'
        },
        titleBarRgb: { main: '0, 40, 86' }
      }
    },
    divisions: {
      TGDK: {
        theme: {
          regularLogoUrl: '/logos/TGDK.png',
          smallLogoUrl: '/logos/TGDK.png'
        }
      },
      TMUI: {
        theme: {
          regularLogoUrl: '/logos/TMUI.png',
          smallLogoUrl: '/logos/TMUI.png'
        }
      },
      TRHI: {
        theme: {
          regularLogoUrl: '/logos/TRHI.png',
          smallLogoUrl: '/logos/TRHI.png'
        }
      },
      TSUA: {
        theme: {
          regularLogoUrl: '/logos/TSUA.png',
          smallLogoUrl: '/logos/TSUA.png'
        }
      },
      //Greenwave
      TXRS: {
        theme: {
          regularLogoUrl: '/logos/TXRS.png',
          smallLogoUrl: '/logos/TXRS.png',
          palette: {
            primary: {
              main: '#327864',
              dark: '#235446',
              light: '#5b9383',
              contrastText: '#fff'
            },
            secondary: {
              main: '#CE9F27',
              dark: '#906f1b',
              light: '#d7b252',
              contrastText: '#000'
            },
            titleBarRgb: { main: '0, 87, 69' }
          }
        }
      }
    }
  },
  PFQ: {
    company: Company.PFQ,
    domain: 'pfqcompanies',
    supportPhoneNumber: '8003486514',
    supportExtension: '6150',
    theme: {
      xLargeLogoUrl: '/logos/PFQ-X-Large.png',
      largeLogoUrl: '/logos/PFQ-Large.png',
      regularLogoUrl: '/logos/PFQ.png',
      smallLogoUrl: '/logos/PFQ.png',
      palette: {
        primary: {
          main: '#002e6c',
          dark: '#00214b',
          light: '#3355a0',
          contrastText: '#fff'
        },
        secondary: {
          main: '#b2282d',
          dark: '#791919',
          light: '#e06666',
          contrastText: '#fff'
        },
        titleBarRgb: { main: '255, 255, 255' }
      }
    },
    divisions: {
      // Falcon Transport
      FALT: {
        theme: {}
      },
      // Pioneer Transport
      PTPW: {
        theme: {}
      },
      // Quaker Transportation
      QKRT: {
        theme: {}
      },
      // Quaker Transport
      QUAK: {
        theme: {}
      },
      // All Roads Transport
      QUDQ: {
        theme: {
          regularLogoUrl: '/logos/QUDQ.png',
          smallLogoUrl: '/logos/QUDQ.png',
          palette: {
            primary: {
              main: '#008eda',
              dark: '#006bb3',
              light: '#3399e6',
              contrastText: '#fff'
            },
            secondary: {
              main: '#002e6c',
              dark: '#00214b',
              light: '#3355a0'
            }
          }
        }
      }
    }
  }
};
